import { CRS } from "./CRS";
import key from "url:../../../assets/cursors/KeyCursor-blue.png";

export function KY3 () {
    return <CRS>
        <img src={key} className='mcs-icon' />
    </CRS>
}